export const buildLooksRareTokenUrl = (address, tokenId) => `https://looksrare.org/collections/${address}/${tokenId}`;
